


















import Vue, {VueConstructor} from 'vue'
import msgrsList from './msgrsList.vue'
import disableMsgr from './disableMsgrButton.vue'
import {USER_ROLE_ADMIN} from '@/constants'
import User from '@/models/Users/User'
export default Vue.extend({
  props: {
    user: {} as () => User,
    options: {}
  },
  components: {
    msgrsList,
    disableMsgr
  },
  data () {
    return {
      editMode: false
    }
  },
  methods: {
    async toggleEditMode () {
      try {
        await this.$store.dispatch('users/loadUser', this.user.getId())
        await this.$store.dispatch('user/loadUser')
        this.editMode = !this.editMode;
      } catch (error) {
        // @ts-ignore
        this.$message.error(this.$t('students.messenger.can_not_update_data'));
      }
    }
  },
  computed: {
    admin (): boolean {
      if (this.$store.state.user.user) {
        return this.$store.state.user.user.checkRole(USER_ROLE_ADMIN)
      }
      return false;
    }
  }
})
